import { useGetMemberLectureData } from '#api/member';
import { Text } from '#atoms';
import { useEffect, useMemo, useState } from 'react';
import { SelecteScheduleBox } from 'src/components/molecules/SelectBox';
import * as S from 'src/components/pages/WeeklyCalenderScheduleRegistration/LectureScheduleContents/styles';

interface GroupRoundInfoProps {
  selectedLecture: {
    personId: string;
    lectureId: string;
    round: number;
    totalRound: number;
    personName: string;
  };
  setSelectedLecture: (
    roundInfo: Partial<{
      personId: string;
      lectureId: string;
      round: number;
      totalRound: number;
    }>
  ) => void;
  isModify: boolean;
  lectureScheduleId?: string;
}
export const GroupRoundInfo = ({
  selectedLecture,
  setSelectedLecture,
  isModify,
  lectureScheduleId
}: GroupRoundInfoProps) => {
  const [totalRoundLength, setTotalRoundLength] = useState<number>(100);

  // 그룹 수업에서는 일단 주석
  // const [roundStatus, setRoundStatus] = useState<RoundStatus>();

  const totalRoundOptions = useMemo<string[]>(() => {
    return Array.from({ length: totalRoundLength || 100 }, (_, i) =>
      String(i + 1)
    );
  }, [totalRoundLength]);

  const roundOptions = useMemo<string[]>(() => {
    return Array.from({ length: selectedLecture.totalRound || 100 }, (_, i) =>
      String(i + 1)
    );
  }, [selectedLecture.totalRound]);

  const { data: nextLectureRound } = useGetMemberLectureData({
    personId: selectedLecture.personId,
    lectureId: selectedLecture.lectureId,
    disable: !!lectureScheduleId
  });

  const handleTotalRound = (value: string | number) => {
    const _round =
      Number(value) < selectedLecture.round ? 1 : selectedLecture.round;

    setSelectedLecture({
      totalRound: Number(value),
      round: _round
    });
  };

  useEffect(() => {
    if (isModify) {
      return;
    }

    const newState: Record<string, number> = {
      round: 0,
      totalRound: 0
    };

    if (nextLectureRound?.lectureId && nextLectureRound?.personId) {
      newState['round'] = nextLectureRound?.round ?? 0;
      newState['totalRound'] = nextLectureRound?.totalRound ?? 0;

      if (nextLectureRound.round && nextLectureRound.totalRound) {
        if (nextLectureRound.round > nextLectureRound.totalRound) {
          // setRoundStatus('expiration');
          setTotalRoundLength(100);

          setSelectedLecture({
            round: nextLectureRound.round,
            totalRound: nextLectureRound.totalRound
          });

          return;
        } else {
          // setRoundStatus('available');
        }
      }
    } else {
      // setRoundStatus('none');
    }

    const newRound = newState?.round ?? selectedLecture.round;
    const newTotalRound = newState?.totalRound ?? selectedLecture.totalRound;
    setTotalRoundLength(newTotalRound);

    setSelectedLecture({
      round: newRound,
      totalRound: newTotalRound
    });
  }, [nextLectureRound, isModify]);

  return (
    <>
      <S.CountBox>
        <Text>{selectedLecture.personName}님 회차: </Text>
        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          <S.ButtonBox>
            <SelecteScheduleBox
              isArrowUse={false}
              value={selectedLecture.round}
              placeholder="현재 회차"
              options={roundOptions}
              disabled={isModify || !selectedLecture.totalRound}
              displayValue={value => `${value} 회차`}
              onClick={value => {
                setSelectedLecture({
                  round: Number(value),
                  totalRound: selectedLecture.totalRound
                });
              }}
            />
            <Text>/</Text>
            <SelecteScheduleBox
              isArrowUse={false}
              value={selectedLecture.totalRound}
              displayValue={value => `${value} 회차`}
              options={totalRoundOptions}
              disabled={isModify}
              placeholder="총 회차"
              onClick={handleTotalRound}
            />
          </S.ButtonBox>
        </div>
      </S.CountBox>

      {/* {roundStatus === 'none' && (
        <S.RoundGuideText roundStatus={roundStatus}>
          총 회차와 현재 회차를 입력하시면 수강권 정보가 자동으로 생성됩니다.
        </S.RoundGuideText>
      )}

      {roundStatus === 'expiration' &&
        selectedLecture.round > selectedLecture.totalRound && (
          <S.RoundGuideText roundStatus={roundStatus}>
            현재 잔여 회차가 없으므로 총 회차를 추가해주세요.
          </S.RoundGuideText>
        )} */}
    </>
  );
};
